import GameObject from '../../../GameObject/GameObject';
import Game from '../../../Game';
import BasePopupHandler from './BasePopupHandler';
import UIItem from '../../../Prototype/UI/UIItem';
import BaseUISystem from '../BaseUISystem';
import UIImageComponent from '../../../Component/UI/Image';
import Text from '../../../Prototype/Text';
import { DEG_TO_RAD } from 'pixi.js';
import TextComponent from '../../../Component/Render/Text';
import ElementComponent from '../../../Component/UI/Element';
import { ILevelDataFile } from '../../Level/Data/ILevelDataFile';
import { GameActions } from '../../../State/Game/GameActions';
import { LevelStatus } from '../../../State/Level/LevelStatus';
import { ContextType } from '../../../State/Game/ContextType';
import { getThreeStarShare } from '../../../Constants/AvatarsAndCrops';
import { getEpisodeIndex } from '../../../Utility/LevelHelper';
import { PopupID } from '../../../State/UI/PopupID';
import { IUIButtonData } from 'Prototype/UI/BaseElements/UIButton';
import { Platform } from 'Utility/Platform';
import { IFieldData } from 'State/World/IFieldData';
import { WorldDataHelper } from 'Utility/WorldDataHelper';
import LeaderboardHelper from '../LeaderboardHelper';
import PIXIRenderer from 'System/Render/PIXIRenderer';

export default class ThreeStarShareHandler extends BasePopupHandler {
    private firstComplete: boolean;
    private levelNumber: number;
    private worldNumber: number;
    private buttons: IUIButtonData[] = [this.continueBtnParams, this.closeBtnParams];

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.THREE_STAR_SHARE_MENU, uiSystem);
    }

    protected createPopup(params?: any): void {
        this.underlayParams.cacheKey = 'splash_harvest';
        this.submitBtnParams.text.textLocalizationKey = 'Share';
        this.submitBtnParams.text.style = Game.style.getStyle('popup.dark_blue_btn');
        this.submitBtnParams.button.cacheKey = 'button_medium_blue';
        this.submitBtnParams.background.layout.offsets = [200, -4, 200, -4];
        this.backgroundParams.layout.constrains = {
            heightMax: 740,
            heightMin: 740,
            widthMax: 1250,
            widthMin: 1250,
        };
        this.backgroundParams.cacheKey = 'blank';
        this.closeBtnParams.button.cacheKey = 'button_close';
        this.closeBtnParams.button.layout.anchors = [0.93, 0.12, 0.93, 0.12];

        const playerIcon: GameObject = UIItem.createImage({
            name: 'player_avatar',
            cacheKey: 'avatar3',
            layout: {
                anchors: [0, 0, 0, 0],
                pivot: [0, 0],
                offsets: [-3, 0, -3, 0],
                scale: [1, 1],
                constrains: {
                    widthMax: 155,
                    widthMin: 155,
                    heightMax: 155,
                    heightMin: 155,
                },
            },
        });

        this.configureShareButtonForNative();
        super.createPopup({
            buttons: this.buttons,
            title: null,
        });

        const base: GameObject = this.element.find('baseLayer');
        base.addChild(playerIcon);

        const levelTxt: GameObject = GameObject.Instantiate(Text, {
            name: 'level_txt',
            text: '',
            style: Game.style.getStyle('popup.new_field'),
            rotation: -25 * DEG_TO_RAD,
            x: 70,
            y: 110,
        });
        this.background.addChild(levelTxt);
    }
    // TODO: Provide world number when showing the popup
    public onShow(params?: { levelNumber: number; firstComplete: boolean }) {
        super.onShow(params);
        this.firstComplete = params.firstComplete;
        this.levelNumber = params.levelNumber;
        this.worldNumber = WorldDataHelper.getWorldNumber(params.levelNumber);

        // TODO: Provide world number as well to avoid getting world number
        const fieldData: IFieldData = WorldDataHelper.getFieldByLevelNumber(params.levelNumber);
        this.background.updateComponent(UIImageComponent, {
            texture: getThreeStarShare(fieldData.id).key,
        });

        // Text
        const quote: GameObject = this.background.find('level_txt');
        quote.getComponent(TextComponent).text = Game.locale
            .getText('Level')
            .replace('[x]', params.levelNumber.toString());

        // Player Avatar
        const playerAvatar: GameObject = this.element.findChildByName('player_avatar');
        const offsets = fieldData.shares.threeStar.offsets;
        const playerAvatarImageComponent = playerAvatar.getComponent(UIImageComponent);
        LeaderboardHelper.setPlayerAvatar('avatar3', Game.sdk.getAvatar(), playerAvatarImageComponent, 155);
        if (offsets) {
            console.log(fieldData, [...offsets]);
            playerAvatar.getComponent(ElementComponent).offsets = [...offsets];
        }
    }

    protected onSubmit(): void {
        GameActions.setContext(ContextType.SHARE_3_STAR_REWARD, {
            levelNumber: this.levelNumber,
            firstComplete: this.firstComplete,
        });
    }

    private configureShareButtonForNative() {
        // if (Game.config.platform !== Platform.ANDROID && Game.config.platform !== Platform.IOS) {
        //     this.buttons.push(this.submitBtnParams);
        //     return;
        // }
        // On native platforms we omit the share button and center the continue button.
        this.continueBtnParams.background.layout.offsets = [0, 0, 0, 0];
    }

    protected resize(screen: { CANVAS_WIDTH: number; CANVAS_HEIGHT: number }): void {
        super.resize(screen);
        if (this.element) {
            this.element.container.resize(PIXIRenderer.renderer.width, PIXIRenderer.renderer.height);
        }
    }
}
